import { createFileRoute } from "@tanstack/react-router";
import StanfordAetnaAllianceInsurance, {
  config,
} from "@/pages/StanfordAetnaAllianceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/stanford-aetna-alliance-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Stanford Aetna Alliance TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Aetna coverage for TMS, SAINT TMS, and SPRAVATO through the Stanford Health Care Alliance. Benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Stanford Aetna Alliance TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Aetna coverage for TMS, SAINT TMS, and SPRAVATO through the Stanford Health Care Alliance. Benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/stanford-aetna-alliance-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/stanford-aetna-alliance-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <StanfordAetnaAllianceInsurance />;
}
